import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core';
import { designTokens } from '../../styles/designTokens';

const useStyles = makeStyles({
    wrapper: {
        minWidth: 371,
        maxWidth: 536,
        '@media (max-width: 900px)': {
            minWidth: 'auto',
            maxWidth: 'none',
            width: '100%',
        },
    },
    autocomplete: {
        width: '100%',
    },
    inputRoot: {
        backgroundColor: `${designTokens.colors.background.card} !important`,
        borderRadius: `${designTokens.borderRadius.button} !important`,
        border: `1px solid ${designTokens.colors.border} !important`,
        padding: '0 !important',
        '& fieldset': {
            border: 'none !important',
        },
        '&:hover': {
            border: `1px solid ${designTokens.colors.border} !important`,
        },
        '&:hover fieldset': {
            border: 'none !important',
        },
        '&.Mui-focused': {
            border: `1px solid ${designTokens.colors.border} !important`,
        },
        '&.Mui-focused fieldset': {
            border: 'none !important',
        },
    },
    input: {
        padding: '13px 65px 12px 16px !important',
        backgroundColor: 'transparent !important',
        borderRadius: `${designTokens.borderRadius.button} !important`,
        ...designTokens.typography.body,
        fontSize: '17px !important',
        fontWeight: '400 !important',
        lineHeight: '22px !important',
        letterSpacing: '0 !important',
        '&::placeholder': {
            color: designTokens.colors.grey[300],
            opacity: 1,
        },
        '&:focus': {
            backgroundColor: 'transparent !important',
            outline: 'none !important',
        },
    },
    endAdornment: {
        right: '12px !important',
    },
    popupIndicator: {
        color: `${designTokens.colors.primary} !important`,
    },
    menuPaper: {
        marginTop: '2px !important',
        borderRadius: `${designTokens.borderRadius.card} !important`,
        border: `1px solid ${designTokens.colors.border} !important`,
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1) !important',
    },
    option: {
        ...designTokens.typography.body,
        fontSize: '17px !important',
        fontWeight: '400 !important',
        lineHeight: '22px !important',
        letterSpacing: '0 !important',
        padding: '10px 16px !important',
        minHeight: '42px !important',
        '&:hover': {
            backgroundColor: `${designTokens.colors.grey[100]} !important`,
        },
        '&[data-focus="true"]': {
            backgroundColor: `${designTokens.colors.primary}20 !important`,
        },
        '&[aria-selected="true"]': {
            backgroundColor: `${designTokens.colors.primary}20 !important`,
            '&:hover': {
                backgroundColor: `${designTokens.colors.primary}30 !important`,
            }
        }
    },
});

const PanelSelector = ({
    value = null,
    options = [],
    onChange,
    noOptionsText = 'Панелі не знайдено.',
}) => {
    const classes = useStyles();

    const getPanelName = (panel) => {
        if (!panel) return '';
        if (panel.superGroupName) {
            const parts = panel.superGroupName.split('.');
            return parts[1] || parts[0];
        }
        return panel.name || '';
    };

    return (
        <div className={classes.wrapper}>
            <Autocomplete
                className={classes.autocomplete}
                options={options}
                value={value}
                onChange={onChange}
                noOptionsText={noOptionsText}
                getOptionLabel={(option) => getPanelName(option)}
                getOptionSelected={(option, value) => option?.id === value?.id}
                popupIcon={<ExpandMoreIcon />}
                ListboxProps={{
                    style: {
                        maxHeight: '300px',
                    }
                }}
                classes={{
                    paper: classes.menuPaper,
                    option: classes.option,
                    endAdornment: classes.endAdornment,
                    popupIndicator: classes.popupIndicator,
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Оберіть панель"
                        InputProps={{
                            ...params.InputProps,
                            classes: {
                                root: classes.inputRoot,
                                input: classes.input,
                            }
                        }}
                    />
                )}
            />
        </div>
    );
};

export default PanelSelector;
